import { X } from "lucide-react";

export const AccountPanelContent = ({ closePanel }) => (
  <>
    <div className="flex items-start justify-between mb-4">
      <div>
        <h2 className="text-xl font-bold text-gray-800">Account</h2>
        <p className="text-sm text-gray-500">Profile & preferences</p>
      </div>
      <button onClick={closePanel} className="p-2 hover:bg-gray-100 rounded-full">
        {/* <X size={20} /> */}
      </button>
    </div>

    <div className="space-y-3">
      <div className="p-3 border rounded-xl">
        <p className="font-medium">Admin</p>
        <p className="text-xs text-gray-500">admin@example.com</p>
      </div>
    </div>
  </>
);